import ApiClient from "../helpers/ApiClient";



// need to change this according to edit events

export const getData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getStudentEvents`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editData = async ({ id, event_name, description, date, location, file}) => {
    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateStudentEvents/${id}`,
            { event_name, description, date, location, file},
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const addData = async ({ event_name, description, date, location, file}) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addStudentEvents`,
            { event_name, description, date, location, file},
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}